import React from 'react';
import { Bell } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { useNotifications } from '@/hooks/useNotifications';

interface NotificationIconProps {
  onClick: () => void;
  hideBadge?: boolean;
}

const NotificationIcon = ({ onClick, hideBadge }: NotificationIconProps) => {
  const { unreadCount, loading } = useNotifications();

  return (
    <Button
      variant="ghost"
      size="sm"
      onClick={onClick}
      className="relative p-2"
    >
      <Bell className="h-5 w-5" />
      {!loading && unreadCount > 0 && !hideBadge && (
        <Badge 
          variant="destructive" 
          className="absolute -top-1 -right-1 h-5 w-5 rounded-full p-0 flex items-center justify-center text-xs"
        >
          {unreadCount > 9 ? '9+' : unreadCount}
        </Badge>
      )}
    </Button>
  );
};

export default NotificationIcon;